var simpleController = angular.module('simpleController', []);

simpleController.controller('homeCtrl', function($rootScope, $scope, wpService, $routeParams, $http) {
	function getSearchPosts(page){
		$('.load-more .btn').addClass('loading');
		wpService.search($routeParams.s, 12, page).then(
		    function(data){
		    	if(data.length > 0){
		    		$scope.noResult = false;
		    		angular.forEach(data, function(post) {
				      	$scope.posts.push(post);
				      	$('.load-more .btn').removeClass('loading');
				      	if(data.length < 12){
			    			$('.load-more .btn').addClass('hide');
			    		}
				    });
		    	}else{
		    		$scope.noResult = true;
		    		$('.search-form-wrap').addClass('active');
		    		$('.load-more .btn').addClass('hide');
		    		$('.search-form-wrap input[type="search"]').focus();
		    	}
		 	},function(error){
		 		console.log(error);
		 	}
	 	);
	}
	if($routeParams.s){
		$scope.search = $routeParams.s;

		var page = 1;
	 	$scope.posts = [];
		getSearchPosts(page);
		$scope.nextPage = function(){
			page++;
	    	getSearchPosts(page);
	  	};
	}else{
		$scope.posts = [];
		$scope.postsExtra = [];
		wpService.postsPaged(4, 1).then(
		    function(data){
		    	$scope.posts = data;
		    	wpService.postsPaged(9, 2).then(
				    function(data){
					    $scope.postsExtra = data;
				 	},function(error){
				 		console.log(error);
				 	}
			 	);
		 	},function(error){
		 		console.log(error);
		 	}
	 	);
	 	$http({
			method: 'GET',
			url: WPAPI.api_url+'/simple/parent-categories'
		}).then(function successCallback(response) {
			$scope.mainCategories = response.data.terms;
		}, function errorCallback(response) {
			console.log(response);
		});
	}
});

simpleController.controller('pageCtrl', function($rootScope, $scope, wpService, $routeParams) {
	if($routeParams.preview){
		wpService.custom('posts?&type[]=page&filter[posts_per_page]=1&filter[name]='+$routeParams.page+'&filter[preview]=true&preview_id='+$routeParams.preview_id+'&preview_nonce='+$routeParams.preview_nonce+'').then(
		    function(data){
		    	$scope.page = data[0];
		    	picturefill();
		 	},function(error){
		 		console.log(error);
		 	}
	 	);
	}else{
		wpService.getBySlug('page',$routeParams.page).then(
		    function(data){
		    	$scope.page = data[0];
		    	picturefill();
		 	},function(error){
		 		console.log(error);
		 	}
	 	);
	}
});
simpleController.controller('postCtrl', function($rootScope, $scope, wpService, $routeParams) {
 	function getPosts(page){
		$('.load-more .btn').addClass('loading');
		wpService.getByTypePaged('post', page , 3).then(
		    function(data){
		    	if(data.length > 0){
		    		angular.forEach(data, function(post) {
						$scope.posts.push(post);
						picturefill();
						$('.load-more .btn').removeClass('loading');
						console.log(data.length);
						if(data.length < 3){
							$('.load-more .btn').addClass('hide');
						}
				    });
		    	}else{
		    		$('.load-more .btn').removeClass('loading');
		    	}
		 	},function(error){
		 		console.log(error);
		 	}

		);
	}
 	var page = 1;
 	$scope.posts = [];
 	getPosts(page);

	$scope.nextPage = function(){
		page++;
    	getPosts(page);
  	};
});
simpleController.controller('singlePostCtrl', function($rootScope, $scope, wpService, $routeParams, $http) {
	if($routeParams.preview){
		wpService.custom('posts?&type[]=post&filter[posts_per_page]=1&filter[name]='+$routeParams.post+'&filter[preview]=true&preview_id='+$routeParams.preview_id+'&preview_nonce='+$routeParams.preview_nonce+'').then(
		    function(data){
		    	$scope.post = data[0];
		    	picturefill();
		 	},function(error){
		 		console.log(error);
		 	}
	 	);
	}else{
		wpService.post_by_slug($routeParams.post).then(
		    function(data){
		    	$scope.post = data[0];
		    	$http({
					method: 'GET',
					url: WPAPI.api_url+'/simple/related/'+data[0].ID,
				}).then(function successCallback(response) {
					$scope.relatedPosts = response.data;
				}, function errorCallback(response) {
					console.log(response);
				});
		 	},function(error){
		 		console.log(error);
		 	}
	 	);
	}
});

simpleController.controller('oppskrifterCtrl', function($rootScope, $scope, wpService, $routeParams, $http) {
 	//get oppskrifter
	function getPosts(page){
		$('.load-more .btn').addClass('loading');
		wpService.getByTypePaged('oppskrifter', page , 12).then(
		    function(data){
		    	if(data.length > 0){
		    		angular.forEach(data, function(post) {
						$scope.posts.push(post);
						picturefill();
						$('.load-more .btn').removeClass('loading');
						if(data.length < 12){
							$('.load-more .btn').addClass('hide');
						}
				    });
		    	}else{
		    		$('.load-more .btn').removeClass('loading');
		    	}
		 	},function(error){
		 		console.log(error);
		 	}

		);
	}

	var page = 1;
 	$scope.posts = [];
 	getPosts(page);

	$scope.nextPage = function(){
		page++;
    	getPosts(page);
  	};
});

simpleController.controller('singleOppskriftCtrl', function($rootScope, $scope, wpService, $routeParams, $http) {
	if($routeParams.preview){
		wpService.custom('posts?&type[]=oppskrifter&filter[posts_per_page]=1&filter[name]='+$routeParams.oppskrift+'&filter[preview]=true&preview_id='+$routeParams.preview_id+'&preview_nonce='+$routeParams.preview_nonce+'').then(
		    function(data){
		    	$scope.post = data[0];
		    	picturefill();
		 	},function(error){
		 		console.log(error);
		 	}
	 	);
	}else{
		wpService.getBySlug('oppskrifter' ,$routeParams.oppskrift).then(
		    function(data){
		    	$scope.post = data[0];
		    	$http({
					method: 'GET',
					url: WPAPI.api_url+'/simple/related/'+data[0].ID,
				}).then(function successCallback(response) {
					$scope.relatedPosts = response.data;
				}, function errorCallback(response) {
					console.log(response);
				});
		 	},function(error){
		 		console.log(error);
		 	}
	 	);
	}

});

simpleController.controller('filmerCtrl', function($rootScope, $scope, wpService, $routeParams) {
	wpService.getByType('filmer', 20).then(
	    function(data){
	    	$scope.posts = data;
	    	picturefill();
	 	},function(error){
	 		console.log(error);
	 	}
 	);
});

simpleController.controller('singleFilmCtrl', function($rootScope, $scope, wpService, $routeParams, $http) {
	if($routeParams.preview){
		wpService.custom('posts?&filmer[]=post&filter[posts_per_page]=1&filter[name]='+$routeParams.post+'&filter[preview]=true&preview_id='+$routeParams.preview_id+'&preview_nonce='+$routeParams.preview_nonce+'').then(
		    function(data){
		    	$scope.post = data[0];
		    	$http({
					method: 'GET',
					url: WPAPI.api_url+'/simple/related/'+data[0].ID,
				}).then(function successCallback(response) {
					$scope.relatedPosts = response.data;
				}, function errorCallback(response) {
					console.log(response);
				});
		 	},function(error){
		 		console.log(error);
		 	}
	 	);
	}else{
		wpService.getBySlug('filmer' ,$routeParams.post).then(
		    function(data){
		    	$scope.post = data[0];
		    	$http({
					method: 'GET',
					url: WPAPI.api_url+'/simple/related/'+data[0].ID,
				}).then(function successCallback(response) {
					$scope.relatedPosts = response.data;
					picturefill();
				}, function errorCallback(response) {
					console.log(response);
				});
		 	},function(error){
		 		console.log(error);
		 	}
	 	);
	}
});


simpleController.controller('categoryCtrl', function($rootScope, $scope, wpService, $routeParams, $http) {
	function getPosts(page){
		$('.load-more .btn').addClass('loading');
		$scope.activeCategory = $routeParams.category;
		wpService.custom('posts?&type[]=post&type[]=oppskrifter&type[]=filmer&filter[posts_per_page]=12&page='+page+'&filter[taxonomy]=category&filter[term]='+$routeParams.category).then(
		    function(data){
		    	angular.forEach(data, function(post) {
			      	$scope.posts.push(post);
			      	$('.load-more .btn').removeClass('loading');
			      	if(data.length < 12){
		    			$('.load-more .btn').addClass('hide');
		    		}
			    });
		 	},function(error){
		 		console.log(error);
		 	}
	 	);
	}
	var page = 1;
 	$scope.posts = [];
	getPosts(page);
	$scope.nextPage = function(){
		page++;
    	getPosts(page);
  	};
  	$http({
		method: 'GET',
		url: WPAPI.api_url+'/simple/page-categories/'+$routeParams.category,
	}).then(function successCallback(response) {
		$scope.pageCategories = response.data;
	}, function errorCallback(response) {
		console.log(response);
	});
});

simpleController.controller('searchCtrl', function($rootScope, $scope, wpService, $routeParams, $http) {
	function getPosts(page){
		$('.load-more .btn').addClass('loading');
		wpService.search($routeParams.s, 12).then(
		    function(data){
		    	angular.forEach(data, function(post) {
			      	$scope.posts.push(post);
			      	picturefill();
			      	$('.load-more .btn').removeClass('loading');
			      	if(data.length < 12){
		    			$('.load-more .btn').addClass('hide');
		    		}
			    });
		 	},function(error){
		 		console.log(error);
		 	}
	 	);
	}

	var page = 1;
 	$scope.posts = [];
	getPosts(page);
	$scope.nextPage = function(){
		page++;
    	getPosts(page);
  	};
});